import React, { useRef } from "react";
import { Upload, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Portrait, YearPicker } from "./Portrait";
import { AgeTimeline } from "./AgeTimeline";

export const PhotoPanel = ({ fs }) => {
  const inputRef = useRef(null);
  return (
    <div className="my-6" data-testid="photo-panel">
      <div className="flex justify-center gap-6">
        <Portrait src={fs.photoUrl} size={110} label="Today" testId="portrait-today" />
        {fs.photoUrl && (
          <Portrait
            src={fs.agedUrl}
            size={110}
            gold
            loading={fs.aging}
            label={fs.futureAgeLabel()}
            testId="portrait-future"
          />
        )}
      </div>
      {fs.photoUrl && !fs.agedUrl && !fs.aging && (
        <p className="text-[11px] text-white/40 text-center mt-3">Talk to Future You and your photo will age automatically.</p>
      )}
      <div className="mt-4">
        <div className="font-mono-label text-center mb-2">Hear from future you at</div>
        <YearPicker years={fs.years} setYears={fs.setYears} labelFor={fs.futureAgeLabel} />
      </div>
      {fs.photoUrl && <p className="text-[10px] text-white/35 text-center mt-2">Aged portraits are artistic simulations.</p>}
      {fs.photoUrl && <AgeTimeline fs={fs} journeyId={fs.journey.id} />}
      {!fs.journey?.photo_consent && (
        <label className="flex gap-2 items-start text-[11px] text-white/55 mt-4 max-w-xs mx-auto cursor-pointer" data-testid="photo-consent">
          <input type="checkbox" className="mt-0.5 accent-amber-300" data-testid="photo-consent-checkbox"
            onChange={async (e) => { if (e.target.checked) { await api.post(`/journey/${fs.journey.id}/photo-consent`); fs.refresh(); } }} />
          I agree that my photo is processed by AI to create fictional, age-progressed images. I can delete them at any time.
        </label>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        className="hidden"
        data-testid="photo-input"
        onChange={(e) => e.target.files?.[0] && fs.upload(e.target.files[0])}
      />
      <div className="flex justify-center gap-2 mt-4">
        <button
          onClick={() => inputRef.current?.click()}
          disabled={fs.uploading || !fs.journey?.photo_consent}
          className="btn-pill text-xs disabled:opacity-40"
          data-testid="photo-upload-btn"
        >
          {fs.uploading ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} />}
          {fs.photoUrl ? "Change photo" : "Upload your photo"}
        </button>
        {fs.photoUrl && (
          <button onClick={async () => { await api.delete(`/journey/${fs.journey.id}/photos`); await fs.refresh(); toast.success("Your photos were deleted."); }}
            className="btn-pill text-xs text-red-300" data-testid="photo-delete-btn"><Trash2 size={12} /> Delete photos</button>
        )}
      </div>
    </div>
  );
};
